import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { Page404Component } from "./page404/page404.component";
import { NoPermissionComponent } from "./no-permission/no-permission.component";

const routes: Routes = [
  {
    path: "404",
    component: Page404Component,
  },
  {
    path: "no-permission",
    component: NoPermissionComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExtrapagesRoutingModule {}
